@if ({ bestPerformingArticles: bestPerformingArticles$ | async, filterIcons:
filterIcons$ | async, filters: filters$ | async, hasError: hasError$ | async,
isLoading: isLoading$ | async, minDate: minDate$ | async, preselectedDateRange:
preselectedDateRangeFilter$ | async, selectedBrandOrgs: selectedBrandOrgs$ |
async, selectedCategories: selectedCategories$ | async, selectedOrderTypes:
selectedOrderTypes$ | async, selectedSort: selectedSort$ | async, currency:
currency$ | async, configStripRedirection: configStripRedirection$ | async }; as
ctx) {
<div class="dashboard">
  <ng-container>
    <div
      class="d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-between w-100 mx-1d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-between w-100 m-2 mb-3"
    >
      <h1
        class="mb-0"
        i18n="
          AnalyticsDashboard|Best Performing Lists
          Title@@bestPerformingArticlesTitle"
      >
        Best Performing Articles
      </h1>
      <epc-best-performing-articles-filters
        class="dashboard-sort d-flex"
        [brandOrgsFilterConfig]="{
          values: ctx.filters?.brandOrgs,
          selected: ctx.selectedBrandOrgs,
          defaultText: defaultFilterText.brandOrgs,
          showAllText: defaultFilterText.brandOrgs,
        }"
        [categoriesFilterConfig]="{
          values: ctx.filters?.categories,
          selected: ctx.selectedCategories,
          defaultText: defaultFilterText.categories,
        }"
        [dateFilterConfig]="{
          minDate: ctx.minDate,
          maxDate: maxDate,
          preselected: ctx.preselectedDateRange,
        }"
        [orderTypeFilterConfig]="{
          values: ctx.filters?.orderTypes,
          selected: ctx.selectedOrderTypes,
          defaultText: defaultFilterText.orderTypes,
        }"
        (filtersChanged)="setStoreParams($event)"
      >
      </epc-best-performing-articles-filters>
    </div>
  </ng-container>
  @if ( !ctx.isLoading && (ctx.hasError || ctx.bestPerformingArticles.length ===
  0)) {
  <epc-dashboard-empty-state
    [hasFiltersSelected]="this.hasFiltersSelected$ | async"
    (clearFilters)="
      setStoreParams({
        brandOrgIds: []
      })
    "
  ></epc-dashboard-empty-state>
  } @else {
  <div class="dashboard-table table-responsive pb-3 px-3">
    <table
      class="table mb-0"
      aria-describedby="Best Performing Article Table"
      i18n-aria-describedby="
        Dashboard|Dashboard Best Performing Article Table
        description@@productListBestPerformingArticlesTableDescription"
    >
      <thead class="dashboard-header">
        <tr>
          <th class="dashboard-header__cover" scope="row"></th>
          <th class="dashboard-header__article" scope="row">
            {{ headerText.article }}
          </th>
          <th class="dashboard-header__total-bought" scope="row">
            <epc-dashboard-column-sort
              [headerText]="headerText.itemBought"
              field="ItemsBought"
              [selectedSort]="ctx.selectedSort"
              (sortingChanged)="sortingClicked($event)"
            ></epc-dashboard-column-sort>
          </th>
          <th class="dashboard-header__revenue" scope="row">
            <epc-dashboard-column-sort
              [headerText]="headerText.revenue"
              field="Revenue"
              [selectedSort]="ctx.selectedSort"
              (sortingChanged)="sortingClicked($event)"
            ></epc-dashboard-column-sort>
          </th>
          <th class="dashboard-header__popularity" scope="row">
            <epc-dashboard-column-sort
              [headerText]="headerText.popularity"
              field="Popularity"
              [selectedSort]="ctx.selectedSort"
              (sortingChanged)="sortingClicked($event)"
              [atxTooltip]="headerTooltipText.popularity"
            ></epc-dashboard-column-sort>
          </th>
          <th class="dashboard-header__category" scope="row">
            {{ headerText.category }}
          </th>
        </tr>
      </thead>
      @if (ctx.isLoading) {
      <ng-container
        [ngTemplateOutlet]="skeletonsTpl"
        [ngTemplateOutletContext]="{ $implicit: skeletons }"
      ></ng-container>
      } @if (!ctx.isLoading) {
      <ng-container
        [ngTemplateOutlet]="bestArticlesTpl"
        [ngTemplateOutletContext]="{ $implicit: ctx.bestPerformingArticles }"
      ></ng-container>
      }
    </table>
  </div>
  <ng-template #skeletonsTpl let-skeletons>
    <tbody class="dashboard-body">
      @for (skeleton of skeletons; track skeleton) {
      <tr class="dashboard-item">
        <td class="p-0">
          <div class="position-relative">
            <atx-skeleton-basic
              [borderRadius]="'0.25rem'"
              [width]="'9.125rem'"
              [height]="'5rem'"
            ></atx-skeleton-basic>
          </div>
        </td>
        <td>
          <atx-skeleton-basic
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </td>
        <td>
          <atx-skeleton-basic
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </td>
        <td>
          <atx-skeleton-basic
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </td>
        <td>
          <atx-skeleton-basic
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </td>
        <td>
          <atx-skeleton-basic
            [height]="baseTextHeightSize"
          ></atx-skeleton-basic>
        </td>
      </tr>
      }
    </tbody>
  </ng-template>
  <ng-template #bestArticlesTpl let-articles>
    <tbody class="dashboard-body">
      @for (article of articles; track trackByProductId($index, article)) {
      <tr class="dashboard-item">
        <td class="p-0 overflow-hidden">
          <div
            class="list-cover position-relative"
            (mouseenter)="shouldMediaPlay$.next(true)"
            (mouseleave)="shouldMediaPlay$.next(false)"
          >
            <atx-media-preview
              atxCardImage="top"
              [class.cursor-pointer]="ctx.configStripRedirection"
              class="list-cover__media position-relative"
              fallbackImageUrl="static/images/placeholder-image.jpg"
              objectFit="contain"
              [media]="convertToMedia(article.imageUrl)"
              [videoAttributes]="{
                controls: false,
                autoplay: false,
                disablePlaceholder: true
              }"
              [activateMedia]="shouldMediaPlay$ | async"
              [showPreviewMedia]="true"
              [maxWidth]="400"
              (click)="
                ctx.configStripRedirection ? openConfigStripPage(article) : null
              "
            >
            </atx-media-preview>
          </div>
        </td>
        <td>
          <div class="list-title">
            <h4 class="list-title__header mb-0 font-weight-bold text-truncate">
              {{ article.title }}
            </h4>
            <p
              class="list-title__subheader mb-0 text-muted font-size-md text-capitalize"
            >
              {{ article.color }}
            </p>
            <p class="list-title__subheader mb-0 text-muted font-size-md">
              {{ article.articleNumber }}
            </p>
          </div>
        </td>
        <td>
          {{ article.totalBought }}
        </td>
        <td>
          {{ article.totalRevenue | formatPrice: ctx.currency }}
        </td>
        <td>
          {{ article.popularity }}
        </td>
        <td>
          <div
            class="with-icon pr-2 rounded-pill filter d-inline-flex align-items-center"
          >
            <div
              class="mr-1 d-flex justify-content-center align-items-center rounded-circle filter-icon"
            >
              <atx-custom-icon
                [icon]="getFilterIconValue(article.category, ctx.filterIcons)"
                [path]="spritesPaths.FILTER"
                size="md"
                class="d-flex"
              ></atx-custom-icon>
            </div>
            {{ article.category }}
          </div>
        </td>
      </tr>
      }
    </tbody>
  </ng-template>
  }
</div>
}
